import { ReactNode } from 'react';

import styled from 'styled-components';

import { theme } from '@styles/theme';

export type StepperVerticalItem = {
  label: ReactNode;
};

export type StepperVerticalProps = {
  items: Array<StepperVerticalItem>;
};

export function StepperVertical({ items }: StepperVerticalProps) {
  return (
    <StepsList role="list">
      {items.map((item, index) => (
        <StepRow key={index}>
          <StepCircle>{index + 1}</StepCircle>
          <LabelContainer>{item.label}</LabelContainer>
        </StepRow>
      ))}
    </StepsList>
  );
}

const StepsList = styled.ol({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
});

const StepRow = styled.li({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.75rem',
});

const StepCircle = styled.div({
  flexShrink: 0,
  height: '1.5rem',
  width: '1.5rem',
  borderRadius: '50%',
  backgroundColor: theme.color.elementBlue100,
  color: theme.color.white100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  font: theme.font.semibold12,
});

const LabelContainer = styled.div({
  flex: 1,
  font: theme.font.regular14,
  color: theme.color.textPrimary,
});
